// @flow
import * as most from 'most';
import * as mostc from '../../crosscutting/mostc';
import * as mA from 'most-adjunct';
import {
  select,
  combineEpics,
} from 'redux-most';
import {
  stopSubmit,
  setSubmitSucceeded,
} from 'redux-form';
import * as r from 'ramda';
import {
  signals as modalSignals,
} from '@team-griffin/redux-modal-router';

import {
  NEGOTIATE,
  CONFIRM_NEGOTIATE,
  emit,
} from '../signals';
import {
  domainNegotiated,
} from '../../domain/messages';
import {
  ModalRoute,
  Hook,
} from '../../core/constants';

export const negotiateEpic = () => r.pipe(
  select(NEGOTIATE),
  mostc.map((action) => modalSignals.open({
    route: ModalRoute.NEGOTIATE,
    params: {
      fqdn: action.payload.fqdn,
    },
  })),
);

export const confirmEpic = () => r.pipe(
  select(CONFIRM_NEGOTIATE),
  mA.switchMap((action) => {
    const {
      payload: {
        fqdn,
      },
    } = action;

    return most.mergeArray([
      most.of(emit(Hook.NEGOTIATE, { fqdn })),
      most.of(stopSubmit('negotiate')).delay(200),
      most.of(setSubmitSucceeded('negotiate')).delay(200),
      most.of(domainNegotiated()).delay(200),
      most.of(modalSignals.close()).delay(1500),
    ]);
  }),
);

export default () => combineEpics([
  negotiateEpic(),
  confirmEpic(),
]);
